import PromptNavigation from "./PromptNavigation";
import PromptDescriptionInfo from "./PromptDescriptionInfo";
import PromptBreadcrumbs from "./PromptBreadcrumb";
import { PageSerializersPromptsLayout } from "types/serializers";

export interface Props {
  prompt: PageSerializersPromptsLayout;
}

export default function PromptHeader({ prompt }: Props) {
  return (
    <div className="space-y-2">
      <PromptBreadcrumbs />
      <PromptDescriptionInfo prompt={prompt} />
      <PromptNavigation prompt={prompt}  />
    </div>
  );
}
